"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[826],{

/***/ 80826:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33616);
var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgMascotaCircle = function SvgMascotaCircle(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "CurrentColor",
    d: "M10.274 6.302a.25.25 0 0 1-.165-.107L9.31 5.003a.71.71 0 0 0-.246-.227.683.683 0 0 0-.32-.085L7.12 4.667h-.003c-.84 0-1.484.145-1.899.854-.386.66-.551 1.785-.551 3.76 0 .134.108.242.241.242.152 0 .266.138.238.286l-.237 1.247a.234.234 0 0 0 .46.087l.277-1.465a.19.19 0 0 1 .188-.155c.38.003.748-.148 1.022-.423.247-.245.426-.58.516-.97l.001-.003.344-1.704a.234.234 0 0 0-.458-.092l-.341 1.69c-.116.493-.46 1.019-1.084 1.019h-.448a.249.249 0 0 1-.248-.252c.025-1.558.176-2.498.48-3.017.268-.458.66-.621 1.497-.621l1.625.024a.228.228 0 0 1 .189.104l.91 1.36a.25.25 0 0 0 .165.107l.989.17a.25.25 0 0 1 .207.247v.022c0 .015-.001.03-.004.045l-.213 1.176c-.064.354-.173.532-.623.588l-1.637.29a.25.25 0 0 0-.206.244l-.01 1.572a.233.233 0 0 0 .467.003l.007-1.167a.25.25 0 0 1 .207-.245l1.234-.218c.326-.042.567-.15.735-.333.144-.155.232-.354.285-.645l.221-1.22a.247.247 0 0 0 .004-.045v-.476a.25.25 0 0 0-.207-.247l-1.185-.204Z"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "CurrentColor",
    fillRule: "evenodd",
    d: "M8 15.57A7.57 7.57 0 1 0 8 .43a7.57 7.57 0 0 0 0 15.14ZM8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16Z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ __webpack_exports__["default"] = (SvgMascotaCircle);

/***/ })

}]);